import { render, staticRenderFns } from "./PExport.vue?vue&type=template&id=0460a2fc&scoped=true&"
import script from "./PExport.vue?vue&type=script&lang=js&"
export * from "./PExport.vue?vue&type=script&lang=js&"
import style0 from "./PExport.vue?vue&type=style&index=0&id=0460a2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460a2fc",
  null
  
)

export default component.exports